<script>
    import {onMount} from "svelte";
    import {getObjects, saveObj} from '../lib/data.js';

    import { notifier } from '@beyonk/svelte-notifications'
    import {querystring} from 'svelte-spa-router'

    import Loader from '../Utilities/Loader.svelte';

    let showArchived = false;

    $: showArchived = new URLSearchParams($querystring).has("archived");

    $: getAssessments = getObjects("assessment", {
        archived: showArchived ? 1: 0,
        fields: ["id", "company_full_name", "archived"]
    });

    async function archiveAssessment(assessment) {
        assessment.archived = true;
        await saveObj("assessment", assessment);
        notifier.success("Assessment Archived");
        getAssessments = getObjects("assessment", {archived: showArchived ? 1: 0})
    }
</script>

{#await getAssessments}
    <Loader />
{:then assessments}
    <div class="title">
        {showArchived ? "Archived" : "Active"} Assessments

        <div class="field has-addons is-pulled-right">
            <p class="control">
                <a href="#/assessments/" class="button {!showArchived ? "is-active" : ""}">Active</a>
            </p>
            <p class="control">
                <a href="#/assessments/?archived=true" class="button {showArchived ? "is-active" : ""}">Archived</a>
            </p>
        </div>
    </div>

    <table class="table is-fullwidth">
        <thead>
            <tr>
                <th>Assessments</th>
                <th style="width: 350px">Actions</th>
            </tr>
        </thead>
        <tbody>
            {#each assessments as assessment}
            <tr>
                <td>{assessment.company_full_name}</td>
                <td>
                    <a href="#/assessment/{assessment.id}" class="button">Edit</a>
                    {#if !showArchived}
                        <a class="button" href="#/assessment/view/{assessment.id}">Open</a>
                        <span class="button" on:click={() => archiveAssessment(assessment) }>Archive</span>
                    {/if}
                </td>
            </tr>
            {/each}
        </tbody>
    </table>
    <a href="#/assessment/" class="button is-primary is-pulled-right">New Assessment</a>
{/await}